<template>
  <div class="testInfo">
    <div class="part">
      <p class="title">批次信息</p>
      <div>
        <span>车牌号：</span><span>{{info.car_number}}</span>
        <img src="./../../../assets/img/lian.png" alt="" style="width:1.26rem;height:0.405rem;margin-top:0.08rem;">
        </div>
      <div><span>摊位号：</span><span>{{info.booth_name}}</span></div>
      <div><span>商户名称：</span><span>{{info.m_name}}</span></div>
      <div><span>供应商：</span><span>{{info.s_name}}</span></div>
      <div><span>上游资质：</span><span></span></div>
      <div>
        <span style="width:0.8rem;"></span>
        <span v-if="prodImgList.length>0">
          <van-uploader v-model="prodImgList" preview-size="1.71rem" image-fit="cover" :deletable='false' :max-count="0"/>
        </span>
        <span v-else style="font-size:0.28rem;color:#FF6474;">暂无证件照片</span>
      </div>
      <div><span>商品信息：</span><span></span></div>
      <div>
        <span style="width:1.4rem;"></span>
        <span>
          <span v-if="list.length==0">暂无商品信息</span>
          <ul v-else>
            <li><span>名称</span><span>重量（kg）</span></li>
            <li v-for="(item,index) in list" :key="index">
              <span class="ellipsis-1">{{item.name}}</span>
              <span class="ellipsis-1">{{item.weight}}</span>
            </li>
            <li><span>合计</span><span>{{totalWeight | returnFloat}}</span></li>
          </ul>
        </span>
      </div>
      <div><span>购货凭证/合格证明：</span><span></span></div>
      <div>
        <span style="width:0.8rem;"></span>
        <span v-if="billImgList.length>0">
          <van-uploader v-model="billImgList" preview-size="1.71rem" image-fit="cover" :deletable='false' :max-count="0"/>
        </span>
        <span v-else style="font-size:0.28rem;color:#FF6474;">暂无票据照片</span>
      </div>
      <p class="title" v-if="sale_list && sale_list.length">销货台账</p>
      <div v-if="sale_list && sale_list.length">
        <van-steps direction="vertical" :active="-1">
          <van-step v-for="(item,index) in sale_list " :key="index">
            <div class="time"><span>{{item.date | toDate}}</span></div>
            <div class="notes" v-if="item.notes">{{item.notes}}</div>
            <div class="imgs">
              <van-uploader preview-size="2rem" v-model="item.imgList" :disabled="true" :deletable="false" :show-upload="false"/>
            </div>  
          </van-step>
        </van-steps>
      </div>
    </div>
  </div>
</template>

<script>
import { timestampToTime,timestampToDate } from '@/utils/timestamp'
import { getBillDetailN, getUsers, updateStatusN, sendUsers,getBillListN,getBillInfo } from '@/api/bill'
import { uploadImg } from '@/api/public'
export default {
  name: 'testInfo',
  data(){
    return {
      type:0,// 是从什么列表状态点进来的
      info:{},// 从路由参数中获取到的某些详情
      show: false,
      list:[],
      detail_fail_role:'',
      role_status:'',
      historyList:[],
      totalWeight:'',
      prodImgList:[],//证件图片
      billImgList:[],//票据
      search: '',//搜索
      searchList: [],
      showUser: false,
      sale_list:[]
    }
  },
  filters:{
    toDate:function(s){
      return s==0?"暂无时间":timestampToDate(s)
    },
    returnFloat:function (value){
      var value=Math.round(parseFloat(value)*1000)/1000;
      var xsd=value.toString().split(".");
      if(xsd.length==1){
        value=value.toString()+".000";
        return value;
      }
      if(xsd.length>1){
        if(xsd[1].length==1){
          value=value.toString()+"00";
        }else if(xsd[1].length==2){
          value=value.toString()+"0";
        }else{
          value=value.toFixed(3);
        }
        return value;
      }
    }
  },
  created(){
    // this.$toast.loading("请求中...")
    getBillInfo({search:this.$route.query.batch_number}).then(res=>{
      if(res.resultCode == 1){
        this.info = res.resultInfo.list[0]
        var list = []
        for (let i = 0; i < res.resultInfo.sale_list.length; i++) {
          const item = res.resultInfo.sale_list[i];
          var imgs = item.imgs.split(",")
          item.imgList = []
          for (let j = 0; j < imgs.length; j++) {
            const url = imgs[j];
            item.imgList.push({url})
          }
          list.push(item)
        }
        this.sale_list = list
        getBillDetailN({id:this.info.id}).then(res=>{
          // this.$toast.clear()
          if(res.resultCode == 1){
            this.list = res.resultInfo.list
            this.historyList = res.resultInfo.history_list
            this.detail_fail_role = res.resultInfo.detail_fail_role
            this.role_status = res.resultInfo.status
            if(this.list.length>0){
              for (let j = 0; j < this.list.length; j++) {
                this.totalWeight = Number(this.totalWeight) + Number(this.list[j].weight)
              }
            }
            if(res.resultInfo.prod_img.length>0){
              let prodImgList = res.resultInfo.prod_img.split(',')
              for (let i = 0; i < prodImgList.length; i++) {
                this.prodImgList.push({url:prodImgList[i],isImage: true})
              }
            }
            if(res.resultInfo.bill_img.length>0){
              let billImgList = res.resultInfo.bill_img.split(',')
              for (let j = 0; j < billImgList.length; j++) {
                this.billImgList.push({url:billImgList[j],isImage: true})
              }
            }

          }
        })
      }
    })



  },
  mounted(){

  },
  methods:{
    
  }
}
</script>

<style lang="less">
.testInfo{
  .van-uploader__wrapper--disabled{
    opacity: 1 !important;
  }
}
</style>
<style lang="less" scoped>
.testInfo{
  background-color: #f5f5f5;
  min-height: 100%;
  overflow: hidden;
  .part{
    width: 6.7rem;
    margin: 0.2rem auto;
    background: #fff;
    border-radius: 0.1rem;
    padding: 0.1rem 0.2rem;
    .title{
      font-size: 0.4rem;
      font-weight: bold;
      margin-bottom: 0.1rem;
    }
    >div:not(.last){
      line-height: 0.61rem;
      display: flex;
      // justify-content: space-between;
      font-size: 0.32rem;
      >span:first-child{
        color: #333;
        min-width: 0.8rem;
      }
      >span:nth-of-type(2){
        color: #666;
        flex-grow: 1;
        overflow: hidden;
      }
      ul{
        border: 0.01rem solid #ccc;
        >li{
          display: flex;
          font-size: 0.28rem;
          line-height: 0.48rem;
          >span{
            width:50%;
            text-align: center;
            box-sizing: border-box;
          }
          >span:first-of-type{
            border-right: 0.01rem solid #ccc;
          }
        }
        >li:not(:last-of-type){
          border-bottom: 0.01rem solid #ccc;
        }
      }
    } 
    .last{
      display: flex;
      justify-content: space-around;
      margin-top: 0.82rem;
      margin-bottom: 0.59rem;
      >span{
        width: 1.7rem;
        line-height: 0.5rem;
        text-align: center;
        border-radius: 0.04rem;
        color: #fff;
        letter-spacing: 0.03rem;
      }
    }
  }
  .bott{
    width: 6.5rem;
    margin: 0.2rem auto;
    background: #fff;
    border-radius: 0.1rem;
    padding: 0.1rem 0.2rem;
  }
  .wrapper{
    width: 6rem;
    padding: 0.3rem;
    .title{
      color: #333;
      font-size: 0.32rem;
    }
    .select{
      position: relative;
      margin-top: 0.17rem;
      margin-bottom: 0.3rem;
      input{
        width: 100%;
        background:none;  
        outline:none;  
        border:none;
        border: 0.01rem solid #CCCCCC;
        line-height: 0.5rem;
        padding: 0.05rem 0.5rem 0.05rem 0.15rem;
        box-sizing: border-box;
        
      }
      .van-icon{
        position: absolute;
        right: 0.15rem;
        line-height: 0.6rem;
      }
    }
    ul{
      border: 0.01rem solid #ccc;
      >li:first-child{
        font-size: 0.32rem;
        color: #333;
      }
      >li:not(:first-child){
        font-size: 0.3rem;
        color: #666;
      }
      >li{
        display: flex;
        font-size: 0.28rem;
        line-height: 0.42rem;
        >span{
          width:50%;
          text-align: center;
          box-sizing: border-box;
        }
        >span:first-of-type{
          border-right: 0.01rem solid #ccc;
        }
      }
      >li:not(:last-of-type){
        border-bottom: 0.01rem solid #ccc;
      }
    }
    .warn{
      background-color: #E4FFF0;
      text-align: center;
      color: #666;
    }
    .deal-btn{
      text-align: center;
      width: 4.6rem;
      line-height: 0.56rem;
      // font-size: 0.3rem;
      margin: 0.6rem auto 0;
      background-color: #00C657;
      box-shadow:0px 2px 20px 0px rgba(51,209,121,0.4);
      color: #fff;
      letter-spacing: 0.2rem;
      border-radius: 0.28rem;
    }
  }
}
</style>